<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  clearable
                  multiple
                  v-bind:collapse-tags="true"
                  @change="
                    selectAllFromSelect('pocketReportsForm.farm_id', farms);
                    showCalendar();
                  "
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="pocketReportsForm.farm_id"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                v-if="isShowCalendar"
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-calendar shadow-sm"
                  size="large"
                  v-model="pocketReportsForm.calendar_sel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in calendars"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('common_words.analyze_by') }} </label>
                <br />
                <el-select
                  clearable
                  @change="changeByInterval"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="pocketReportsForm.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsInterval"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="
                  pocketReportsForm.bySel != 'week' &&
                  pocketReportsForm.bySel != 'year'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="rangeDate"
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  pocketReportsForm.bySel == 'week' ||
                  pocketReportsForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="pocketReportsForm.week_sel_init = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="pocketReportsForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  pocketReportsForm.bySel == 'week' &&
                  pocketReportsForm.year_sel_init
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="pocketReportsForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years[
                      pocketReportsForm.year_sel_init
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  pocketReportsForm.bySel == 'week' ||
                  pocketReportsForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="pocketReportsForm.week_sel_end = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="pocketReportsForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  pocketReportsForm.bySel == 'week' &&
                  pocketReportsForm.year_sel_end
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="pocketReportsForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years[
                      pocketReportsForm.year_sel_end
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
            <br />
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="pocketCatch"
        :title="$t('production.bagged_fruit_cluster')"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex()">
            <div class="custom-flex">
              <el-select
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="paginationE.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in paginationE.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead class="cusmtom-thead-color">
                  <tr>
                    <td
                      :rowspan="showHeatAccumulatorData() ? 5 : 4"
                      class="text-center"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <span v-if="pocketReportsForm.farm_id.length > 1"
                        ><strong>{{ $t('common_words.farm') }}</strong></span
                      >
                      <span v-else
                        ><strong>{{
                          $t('common_words.allotment')
                        }}</strong></span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td
                      :rowspan="showHeatAccumulatorData() ? 5 : 4"
                      class="text-center"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <strong>{{ $t('common_words.area_roamed') }} (ha)</strong>
                    </td>
                  </tr>
                  <tr v-if="showHeatAccumulatorData()">
                    <td
                      v-for="(heat, indexWeek) in reports.report1.heats[0]"
                      class="text-center"
                      :key="`${indexWeek}`"
                      :colspan="heat[1] ? heat[1] : 1"
                    >
                      <strong v-if="heat[0]">{{ heat[0] }} (°D)</strong>
                      <el-tooltip
                        v-else
                        class="item"
                        effect="dark"
                        placement="bottom"
                      >
                        <div slot="content">
                          <span
                            v-html="Number(heat[0]) === 0 ? getTooltipGD : ''"
                          ></span>
                        </div>
                        <strong>0 (°D)</strong>
                      </el-tooltip>
                    </td>
                    <td
                      rowspan="5"
                      class="text-center"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <strong>{{ $t('common_words.total') }}</strong>
                    </td>
                    <td
                      v-if="pocketReportsForm.farm_id.length > 1"
                      rowspan="5"
                      class="text-center"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <strong>{{ $t('common_words.total') }} (°D)</strong>
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="text-center"
                      style="font-size: smaller"
                      v-for="(data, week) in reports.report1.columns"
                      :key="week"
                      :colspan="data.length"
                    >
                      <strong>{{ week }}</strong>
                    </td>
                    <td
                      v-if="!showHeatAccumulatorData()"
                      rowspan="3"
                      class="text-center"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <strong>{{ $t('common_words.total') }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <template
                      v-for="(ribbons, indexWeek) in reports.report1.columns"
                    >
                      <td
                        class="text-center"
                        v-bind:style="
                          'font-size: smaller;background-color:' +
                          ribbon.color_code +
                          ';color:' +
                          ribbon.color_text
                        "
                        v-for="(ribbon, indexRibbon) in ribbons"
                        :key="`${indexWeek}-${indexRibbon}`"
                      >
                        <strong>{{ ribbon.color_name }}</strong>
                      </td>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, lot) in pagedRows" :key="lot">
                    <td class="text-center white-space-nowrap">{{ row }}</td>
                    <td class="text-center white-space-nowrap">
                      {{ reports.report1.covered_areas[row] }}
                    </td>
                    <template
                      v-for="(ribbons, indexWeek) in reports.report1.columns"
                    >
                      <td
                        v-for="(ribbon, indexRibbon) in ribbons"
                        :key="`${indexWeek}-${indexRibbon}`"
                      >
                        <span>{{
                          formatNumber(
                            getNumberCluster(
                              reports.report1.data[indexWeek][row],
                              ribbon.color_name
                            )
                          )
                        }}</span>
                      </td>
                    </template>
                    <td class="text-center">
                      <strong>{{
                        formatNumber(calculateTotalRow(row, reports.report1))
                      }}</strong>
                    </td>
                    <td
                      class="text-center"
                      v-if="
                        pocketReportsForm.farm_id.length > 1 &&
                        showHeatAccumulatorData()
                      "
                    >
                      <strong>{{
                        formatNumber(calculateTotalRowGD(row, reports.report1))
                      }}</strong>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="text-muted text-center">
                      <strong>{{ $t('common_words.total') }}</strong>
                    </td>
                    <td class="text-center" style="font-size: smaller">
                      <strong>{{
                        formatNumber(
                          calculateTotalColumn(
                            null,
                            reports.report1,
                            'covered_area'
                          )
                        )
                      }}</strong>
                    </td>
                    <template
                      v-for="(ribbons, indexWeek) in reports.report1.columns"
                    >
                      <td
                        v-for="(ribbon, indexRibbon) in ribbons"
                        :key="`${indexWeek}-${indexRibbon}`"
                      >
                        <strong>{{
                          formatNumber(
                            calculateTotalColumn(
                              ribbon.color_name,
                              reports.report1.data[indexWeek]
                            )
                          )
                        }}</strong>
                      </td>
                    </template>

                    <td class="text-center" style="font-size: smaller">
                      <strong>{{
                        formatNumber(
                          calculateTotalColumn(null, reports.report1)
                        )
                      }}</strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ from + 1 }}
                  {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                  {{ total }} {{ $t('table2.entries') }}
                </p>
              </div>
              <l-pagination
                class="pagination-no-border"
                v-model="paginationE.currentPage"
                :per-page="paginationE.perPage"
                :total="paginationE.total"
                pageFirst="false"
                pageLast="false"
              ></l-pagination>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div class="row" style="padding-right: 13px; padding-left: 13px">
            <div class="col-6" v-if="isPDF()">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportToPDF(1)"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel(1)"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </card>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="pocketCatch"
        :title="$t('production.banana_cutted_cluster')"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex()">
            <div class="custom-flex">
              <el-select
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="paginationD.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in paginationD.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead class="cusmtom-thead-color">
                  <tr>
                    <td
                      :rowspan="showHeatAccumulatorData() ? 5 : 4"
                      class="text-center"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <span v-if="pocketReportsForm.farm_id.length > 1"
                        ><strong>{{ $t('common_words.farm') }}</strong></span
                      >
                      <span v-else
                        ><strong>{{
                          $t('common_words.allotment')
                        }}</strong></span
                      >
                    </td>
                    <td
                      :rowspan="showHeatAccumulatorData() ? 5 : 4"
                      class="text-center"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <strong>{{ $t('common_words.area_roamed') }} (ha)</strong>
                    </td>
                  </tr>
                  <tr v-if="showHeatAccumulatorData()">
                    <td
                      class="text-center"
                      v-for="(heat, indexWeek) in reports.report2.heats[0]"
                      :key="`${indexWeek}`"
                      :colspan="heat[1] ? heat[1] : 1"
                    >
                      <strong v-if="heat[0]">{{ heat[0] }} (°D)</strong>
                      <el-tooltip
                        v-else
                        class="item"
                        effect="dark"
                        placement="bottom"
                      >
                        <div slot="content">
                          <span
                            v-html="Number(heat[0]) === 0 ? getTooltipGD : ''"
                          ></span>
                        </div>
                        <strong>0 (°D)</strong>
                      </el-tooltip>
                    </td>
                    <td rowspan="5" class="text-center custom-header-label">
                      <strong>{{ $t('common_words.total') }}</strong>
                    </td>
                    <td
                      v-if="pocketReportsForm.farm_id.length > 1"
                      rowspan="5"
                      class="text-center"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <strong>{{ $t('common_words.total') }} (°D)</strong>
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="text-center"
                      style="font-size: smaller"
                      v-for="(data, week) in reports.report2.columns"
                      :key="week"
                      :colspan="data.length"
                    >
                      <strong>{{ week }}</strong>
                    </td>
                    <td
                      v-if="!showHeatAccumulatorData()"
                      rowspan="3"
                      class="text-center"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <strong>{{ $t('common_words.total') }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <template
                      v-for="(ribbons, indexWeek) in reports.report2.columns"
                    >
                      <td
                        class="text-center"
                        v-bind:style="
                          'font-size: smaller;background-color:' +
                          ribbon.color_code +
                          ';color:' +
                          ribbon.color_text
                        "
                        v-for="(ribbon, indexRibbon) in ribbons"
                        :key="`${indexWeek}-${indexRibbon}`"
                      >
                        <strong>{{ ribbon.color_name }}</strong>
                      </td>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, lot) in pagedRowsD" :key="lot">
                    <td class="text-center white-space-nowrap">{{ row }}</td>
                    <td class="text-center white-space-nowrap">
                      {{ formatNumber(reports.report2['covered_areas'][row]) }}
                    </td>
                    <template
                      v-for="(ribbons, indexWeek) in reports.report2.columns"
                    >
                      <td
                        v-for="(ribbon, indexRibbon) in ribbons"
                        :key="`${indexWeek}-${indexRibbon}`"
                      >
                        <span>
                          {{
                            formatNumber(
                              getNumberCluster(
                                reports.report2.data[indexWeek][row],
                                ribbon.color_name
                              )
                            )
                          }}
                        </span>
                      </td>
                    </template>
                    <td class="text-center">
                      <strong>{{
                        formatNumber(calculateTotalRow(row, reports.report2))
                      }}</strong>
                    </td>
                    <td
                      class="text-center"
                      v-if="
                        pocketReportsForm.farm_id.length > 1 &&
                        showHeatAccumulatorData()
                      "
                    >
                      <strong>{{
                        formatNumber(calculateTotalRowGD(row, reports.report2))
                      }}</strong>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="text-muted text-center">
                      <strong>{{ $t('common_words.total') }}</strong>
                    </td>
                    <td class="text-center" style="font-size: smaller">
                      <strong>{{
                        formatNumber(
                          calculateTotalColumn(
                            null,
                            reports.report2,
                            'covered_area'
                          )
                        )
                      }}</strong>
                    </td>
                    <template
                      v-for="(ribbons, indexWeek) in reports.report2.columns"
                    >
                      <td
                        v-for="(ribbon, indexRibbon) in ribbons"
                        :key="`${indexWeek}-${indexRibbon}`"
                      >
                        <strong>{{
                          formatNumber(
                            calculateTotalColumn(
                              ribbon.color_name,
                              reports.report2.data[indexWeek]
                            )
                          )
                        }}</strong>
                      </td>
                    </template>
                    <td class="text-center" style="font-size: smaller">
                      <strong>{{
                        formatNumber(
                          calculateTotalColumn(null, reports.report2)
                        )
                      }}</strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ fromD + 1 }}
                  {{ $t('table2.a') }} {{ toD }} {{ $t('table2.of') }}
                  {{ totalD }} {{ $t('table2.entries') }}
                </p>
              </div>
              <l-pagination
                class="pagination-no-border"
                v-model="paginationD.currentPage"
                :per-page="paginationD.perPage"
                :total="paginationD.total"
                pageFirst="false"
                pageLast="false"
              ></l-pagination>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              Usted no tiene permisos para indexar la información registrada en
              el sistema
            </h5>
          </div>
          <div class="row" style="padding-right: 13px; padding-left: 13px">
            <div class="col-6" v-if="isPDF()">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportToPDF(2)"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel(2)"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import { RadioGroup, Radio, RadioButton } from 'element-ui';
import Formatter from 'src/class/Formatter';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import paginationDebunchados from './paginationDebunchados';
import paginationEmbolsados from './paginationEmbolsados';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
  },

  computed: {
    calendars() {
      if (this.pocketReportsForm.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          this.pocketReportsForm.farm_id.forEach((elFarm) => {
            if (element.id == elFarm) {
              calendars = element.calendars;
            }
          });
        });

        return calendars;
      } else {
        return [];
      }
    },
    getTooltipGD() {
      return `<div class='mx-1 my-3 text-left' style="width: 200px">
          <h6>${i18n.t('show_notification.production.displayed_data')}:</h6>
          <ul style='margin-left: -15px; font-size: 14px'>
            <li>${i18n.t('show_notification.production.associated_farm')}</li>
            <li>${i18n.t(
              'show_notification.production.crop_base_temperature'
            )}</li>
            <li>${i18n.t(
              'show_notification.production.temperature_indicated'
            )}</li>
          </ul>
      </div>`;
    },
    ...paginationEmbolsados.functions,
    ...paginationDebunchados.functions,
    optionsInterval() {
      return {
        0: { label: i18n.t('common_words.day'), value: 'daterange' },
        1: { label: i18n.t('common_words.week'), value: 'week' },
        2: { label: i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: i18n.t('common_words.year'), value: 'year' },
      };
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  data() {
    return {
      pocketReportsForm: {
        bySel: null,
        year_sel_init: null,
        week_sel_init: null,
        year_sel_end: null,
        week_sel_end: null,
        year_sel: null,
        calendar_sel: null,
        farm_id: [],
        user_id: this.$store.state.auth.user.id,
      },
      activeName: '1',
      paginationE: paginationEmbolsados.paginationE,
      paginationD: paginationDebunchados.paginationD,
      typedatepicket: 'daterange',
      row: null,
      valueCollapse: null,
      reports: [],
      interval: 'Semana',
      years: [],
      farms: [],
      pocketCatch: false,
      isShowCalendar: false,
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },

    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    getNumberCluster(data, ribbon) {
      if (data) {
        const pocketData = data.find((item) => item.color_name === ribbon);

        return pocketData ? pocketData.number_clusters : 0;
      }

      return 0;
    },

    showCalendar() {
      this.pocketReportsForm.calendar_sel = null;
      this.isShowCalendar = true;
      this.pocketCatch = false;

      for (let index = 0; index < Object.values(this.farms).length; index++) {
        const element = Object.values(this.farms)[index];

        this.pocketReportsForm.farm_id.forEach((elFarm) => {
          if (element.id != 0 && element.id == elFarm) {
            if (element.calendars.length > 1) {
              this.pocketReportsForm.calendar_sel = null;
              this.isShowCalendar = true;
            } else {
              if (element.calendars.length == 1) {
                this.pocketReportsForm.calendar_sel = element.calendars[0].id;
                this.isShowCalendar = false;
              }
            }
          }
        });
      }

      this.isShowCalendar = false;
    },

    changeByInterval() {
      this.pocketCatch = false;
      for (
        let index = 0;
        index < Object.values(this.optionsInterval).length;
        index++
      ) {
        const element = Object.values(this.optionsInterval)[index];
        if (element.label == this.pocketReportsForm.bySel) {
          this.typedatepicket = element.value;
          break;
        }
      }
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    formatNumber(value) {
      return Formatter.formatNumber(value);
    },

    validate() {
      if (
        this.pocketReportsForm.farm_id == null ||
        this.pocketReportsForm.farm_id.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (
        (this.pocketReportsForm.bySel == 'year' &&
          (this.pocketReportsForm.year_sel_init == null ||
            this.pocketReportsForm.year_sel_end == null)) ||
        (this.pocketReportsForm.bySel == 'week' &&
          this.isYearSelRequired() &&
          this.pocketReportsForm.year_sel_init == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.pocketReportsForm.week_sel_init == null &&
        this.pocketReportsForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.isYearSelRequired() &&
        this.pocketReportsForm.year_sel_end == null &&
        this.pocketReportsForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.pocketReportsForm.week_sel_end == null &&
        this.pocketReportsForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.pocketReportsForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else {
        this.loadPocketReport();
      }
    },

    calculateTotalRowGD(row, object) {
      return object.heats[1][row].reduce((acc, heat) => acc + heat, 0);
    },

    calculateTotalRow(row, object) {
      let total = 0;
      Object.values(object.data).forEach((element) => {
        if (element[row]) {
          total += element[row].reduce(
            (acc, item) => acc + item.number_clusters,
            0
          );
        }
      });

      return total;
    },

    calculateTotalColumn(column, object, type = 'number_clusters') {
      let total = 0;
      if (column) {
        if (!object) total = 0;
        else {
          Object.values(object).forEach((element) => {
            total += element
              .filter((item) => item.color_name === column)
              .reduce((acc, item) => acc + item.number_clusters, 0);
          });
        }
      } else {
        if (type === 'covered_area') {
          total = Object.values(object.covered_areas).reduce(
            (prev, curr) => prev + curr,
            0
          );
        }

        if (type === 'number_clusters') {
          Object.values(object.data).forEach((element) => {
            Object.values(element).forEach((item) => {
              total += item.reduce(
                (acc, item) => acc + item.number_clusters,
                0
              );
            });
          });
        }
      }

      return type === 'covered_area' ? total.toFixed(2) : total;
    },

    loadData() {
      let data = {
        farm: this.pocketReportsForm.farm_id,
        init:
          parseInt(this.pocketReportsForm.year_sel_init) * 100 +
          parseInt(this.pocketReportsForm.week_sel_init),
        end:
          parseInt(this.pocketReportsForm.year_sel_end) * 100 +
          parseInt(this.pocketReportsForm.week_sel_end),
        bySel: this.pocketReportsForm.bySel,
      };

      switch (this.pocketReportsForm.bySel) {
        case 'year':
          data.init = this.pocketReportsForm.year_sel_init;
          data.end = this.pocketReportsForm.year_sel_end;
          break;
        case 'monthrange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1])
            .endOf('month')
            .format('YYYY-MM-DD');
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    exportToPDF(option) {
      let data = this.loadData();
      data.route = 'pockets/reports/pdf';
      data.option = option;
      data.name_file = `${i18n.t('production.bagged_report')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel(option) {
      let data = this.loadData();
      data.route = 'pockets/reports/excel/';
      data.option = option;
      data.name_file = `${i18n.t('production.bagged_report')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    loadPocketReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'pockets/reports';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data.report1.data.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.reports = response.data;
            this.pocketCatch = true;
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },

    isYearSelRequired() {
      return this.interval == 'Semana';
    },

    isWeekSekRequired() {
      return this.interval == 'Semana';
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);

      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = this.concatAll(response.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('calendars/getyearsbusiness').then((response) => {
      this.years = response.data;
      this.showHideLoading();
    });

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('pockets');
  },

  destroyed() {
    this.deselectedItemOnMenu('pockets');
  },
};
</script>
